import { padStart } from 'lodash';

export const zeroPad = n => padStart(n, 2, '0');

export const minutesToHours = minutes => {
  const min = Math.abs(minutes);
  return `${minutes < 0 ? '-' : ''}${(min/60).toFixed(2)}`;
};

export const PREFERRED_DATETIME_FORMAT = 'MM/DD/YYYY hh:mm A';
export const PREFERRED_DATE_FORMAT = 'MM/DD/YYYY';
export const CONVERT_DATE_FORMAT = 'YYYY/MM/DD hh:mm:ss';